import React from 'react';

export const Spacer = ({ width, height }) => (
    <div
        style={{
            width: width,
            maxWidth: width,
            minWidth: width,
            height: height,
            maxHeight: height,
            minHeight: height
        }}
    />
);

export default Spacer;
